import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.g5{min-height:100vh;}.ssr-plugin'
import '.eb{background:var(--palette-white);}.ssr-plugin'
import '.al{max-width:77.5rem;}.ssr-plugin'
import '.g6{align-self:center;}.ssr-plugin'
import '.ae{flex-shrink:0;}.ssr-plugin'
import '.g7{padding-block:1rem;}.ssr-plugin'
import '.f9{gap:0.75rem;}.ssr-plugin'
import '.g8{height:3rem;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ar{flex-wrap:wrap;}.ssr-plugin'
import '.g9{height:0.25rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ga{border-radius:999px;}.ssr-plugin'
import '.gb{background:var(--gray-200);}.ssr-plugin'
import '.ai{height:100%;}.ssr-plugin'
import '.cl{background:var(--brand-primary);}.ssr-plugin'
import '.gc{transition:width 0.3s ease;}.ssr-plugin'
import '.ak{flex:1;}.ssr-plugin'
import '.d5{min-height:0px;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.gd{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
  progress,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
  progress?: { current: number; total: number }
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d e g5 eb"
      >
        <div className="al g6 ae"
          style={{
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          <nav className="g7 d e f9"
          >
            <div className="g8 d ao t ar"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </div>
            {progress && progress.total > 0 && (
              <div className="g9 n ga gb"
              >
                <div className="ai ga cl gc"
                  style={{
                    width: `${(progress.current / progress.total) * 100}%`,}}
                />
              </div>
            )}
          </nav>
        </div>
        <div className="ak d5 d e r gd al g6"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
